import type { WatchSource } from "vue";

// Headless UI only treats dialogs as nested when they are nested in the component tree.
// Global dialogs (e.g. the confirm in app.vue) are siblings of every other dialog, so a click
// inside them counts as an outside click (and Escape reaches both) and all open dialogs close at once.
// Closing two dialogs at the same time can leave the page `inert` (frozen, no clicks or hover).
// A dialog that holds the lock keeps all other modals from closing on outside click / Escape.
export const useDialogCloseLock = () => {
  const locks = useState("dialog-close-locks", () => 0);

  const isCloseLocked = computed(() => locks.value > 0);

  const lockWhile = (active: WatchSource<boolean>) => {
    watch(
      active,
      (isActive, _, onCleanup) => {
        if (!isActive) return;
        locks.value++;
        onCleanup(() => locks.value--);
      },
      { immediate: true },
    );
  };

  return { isCloseLocked, lockWhile };
};
